// middleware/manutencao.ts
export default defineNuxtRouteMiddleware((to, from) => {
  // Ativa/desativa modo manutenção (pode ser variável estática, config, API, env, etc)
  const manutencaoAtiva = true;

  // Rotas em manutenção - paths exatos ou prefixos
  const rotasEmManutencao = [
    '/admin',
    // '/funarpen/conselho-diretor',
    // '/funarpen/conselho-fiscal',
    // '/funarpen/regimento-interno',
    // '/funarpen/sobre',
    // '/funarpen/instrucoes-normativas',
    // '/funarpen/selos',
    // '/funarpen/contato/lgpd',
    // '/funarpen/contato/fale-conosco',
    // '/funarpen/organograma',
    // '/funarpen/consultas/consulta-certidao',
    // '/funarpen/consultas/consulta-selos-autenticacao',
    // Exemplo: '/admin' para tudo que começa com /admin
  ];

  // Permitir acesso livre à página de manutenção para evitar loop
  if (to.path === '/manutencao/manutencao') return;

  // Se manutenção desativada, deixa passar
  if (!manutencaoAtiva) return;

  // Verifica se a rota atual está na lista de manutenção
  const rotaEmManutencao = rotasEmManutencao.some((rota) => {
    // Se quiser que prefixo funcione, descomente abaixo:
    // return to.path === rota || to.path.startsWith(rota);

    // Aqui só verifica igualdade exata
    return to.path === rota;
  });

  if (rotaEmManutencao) {
    return navigateTo('/manutencao/manutencao');
  }
});
